export default {
  activeTimerDetectedModal: {
    title: 'Hold On — Timer in Progress',
    action: 'Cancel',
  },
};
